'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarIcon = function (_React$Component) {
    _inherits(CalendarIcon, _React$Component);

    function CalendarIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CalendarIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarIcon.__proto__ || Object.getPrototypeOf(CalendarIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: '24.009', height: '24.021', viewBox: '0 0 24.009 24.021' },
                _react2.default.createElement(
                    'g',
                    { id: 'calendar-check-outlined', transform: 'translate(0 0.021)' },
                    _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: '24', height: '24', fill: 'transparent' }),
                    _react2.default.createElement(
                        'g',
                        { id: 'calendar-check', transform: 'translate(-639.255 -2846.75)' },
                        _react2.default.createElement('path', { id: 'Rectangle-path_82', 'data-name': 'Rectangle-path 82', d: 'M639.755,2852.249a1.5,1.5,0,0,1,1.5-1.5h19.5a1.5,1.5,0,0,1,1.5,1.5v16.5a1.5,1.5,0,0,1-1.5,1.5h-19.5a1.5,1.5,0,0,1-1.5-1.5Z', transform: 'translate(0.263 -0.271)', fill: 'transparent', stroke: primary, 'stroke-linejoin': 'round', strokeWidth: '1.5' }),
                        _react2.default.createElement('path', { id: 'Shape_1252', 'data-name': 'Shape 1252', d: 'M639.755,2856.75h22.5', transform: 'translate(0.263 -0.272)', fill: 'transparent', stroke: primary, 'stroke-linejoin': 'round', strokeWidth: '1.5' }),
                        _react2.default.createElement('path', { id: 'Shape_1253', 'data-name': 'Shape 1253', d: 'M645.755,2853v-5.25', transform: 'translate(0.261 -0.27)', fill: 'transparent', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '1.5' }),
                        _react2.default.createElement('path', { id: 'Shape_1254', 'data-name': 'Shape 1254', d: 'M656.255,2853v-5.25', transform: 'translate(0.26 -0.27)', fill: 'transparent', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '1.5' }),
                        _react2.default.createElement('path', { id: 'Shape_1255', 'data-name': 'Shape 1255', d: 'M654.754,2860.5l-4.5,6-3-3', transform: 'translate(0.261 -0.272)', fill: 'transparent', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '1.5' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CalendarIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                this.getIcon(size, size, this.props.primary)
            );
        }
    }]);

    return CalendarIcon;
}(_react2.default.Component);

exports.default = CalendarIcon;